module.exports = __webpack_public_path__ + "static/media/dashboard.96efb3ee.svg";